import gPhoneNumber from 'google-libphonenumber';

const phoneUtil = gPhoneNumber.PhoneNumberUtil.getInstance();
export const PNF = gPhoneNumber.PhoneNumberFormat;

export default phoneUtil;
